<template>
  <header class="dashboard-header">
    <div class="container">
      <div class="left">
        <span class="logo">
          <span class="logo-link">
            <img :src="baseURL + 'static/entrupy_logo.png'" class="logo-img" />
            <span class="dashboard-name"> Dashboard </span>
          </span>
        </span>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "MiniDashboardHeader",
  computed: {
    baseURL() {
      return process.env.BASE_URL
    },
  },
})
</script>

<style scoped lang="scss">
.desktop-health-down {
  margin: 5px;
  color: red;
  background-color: black;
  font-weight: bold;
  white-space: nowrap;
}

.desktop-health-degraded {
  margin: 5px;
  background-color: black;
  color: yellow;
  font-weight: bold;
  white-space: nowrap;
}

.circle {
  border-radius: 50%;
  margin-left: 5px;
  width: 20px;
  height: 20px;
}

.mobile-health-down {
  background-color: red;
}

.mobile-health-degraded {
  @apply bg-needs-review;
}

.mobile-health-ok {
  background-color: rgb(20%, 100%, 00%);
}

.menu {
  display: inline-block;
}

.dashboard-header {
  font-family: sans-serif;
  background-color: #333333;
  height: 32px;
  width: 100%;
  color: white;
  position: sticky;
  top: 0;
  box-sizing: border-box; /* so as to not include padding and make it easier to make sticky elements precisely positioned*/
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  height: 100%;
  width: 100%;
  color: white;
}

.left {
  display: flex;
  align-items: center;
  height: 100%;
}

.center {
  display: flex;
  align-items: center;
  height: 100%;
}

.right {
  display: flex;
  align-items: center;
  margin-right: 0.35em;
}

.logo,
.logo-link {
  display: flex;
  align-items: center;
}

.logo {
  margin-left: 0.2em;
  margin-right: 0.5em;
  box-sizing: border-box;
}

.logo-img {
  max-height: 20px;
  background-color: white;
  border: 1px solid black;
}

.dashboard-name {
  display: inline-block;
  font-size: 16pt;
  line-height: 1;
  margin-left: 0.1em;
  font-weight: bold;
  color: #ffc05c;
}

.username {
  font-weight: bold;
}

.login {
  white-space: nowrap;
  margin-right: 10px;
}

.logout-button a {
  color: #ffc05c;
}

.logout-button a:hover {
  color: white;
}

.debug-button {
  display: inline-block;
  color: black;
}

.burger-menu {
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 0.3em;
}

.logo-link {
  background-color: transparent;
  text-decoration: none;
}

.vmwarning {
  color: yellow;
  font-weight: bold;
  padding-right: 3em;
  font-size: larger;
}

.vmPopup {
  position: fixed;
  left: calc(50% - 13em);
  top: calc(50% - 8em);
  width: 26em;
  border: thin grey solid;
  border-radius: 10px;
  padding: 20px;
  background: white;
  color: black;
  box-shadow: 1px 1px 4px grey, 0 0 10px white;
}

.vmPopup h3 {
  color: darkgoldenrod;
  margin: 0px;
}

.vmPopup a {
  color: #55f;
  font-size: smaller;
}

.pure-menu-link {
  color: white !important;
  padding: 0.5em 0 !important;
}

.pure-menu-link:hover,
.pure-menu-link:active {
  background-color: inherit !important;
}

.pure-menu-link:focus {
  background-color: inherit;
}

.pure-menu-link::before {
  content: "";
  position: absolute;
  top: 100%;
  width: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 3px;
  background: #ffc05c;
  opacity: 0;
  transform: translate(0, -8px);
  text-align: center;
}

.pure-menu-link:hover::before,
.router-link-active::before {
  opacity: 1;
}

.pure-menu-item {
  margin: 0 0.35em !important;
}

body {
  color: #222222; /* slightly less contrast */
}

.button-xsmall {
  font-size: 70%;
}

.button-small {
  font-size: 85%;
}

.button-large {
  font-size: 110%;
}

.button-xlarge {
  font-size: 125%;
}

.button-success,
.button-error,
.button-warning,
.button-secondary {
  color: white;
  border-radius: 4px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.button-success {
  @apply bg-highlight-authentic;
}

.button-error {
  background: rgb(202, 60, 60);
}

.button-warning {
  background: rgb(223, 117, 20);
}

.button-secondary {
  background: rgb(66, 184, 221);
}

.pure-form select,
.pure-form input {
  padding: 0 !important;
  line-height: 28px !important;
  height: 28px !important;
}

.pure-form input {
  padding: 5px !important;
}
</style>
